<div class="table-box">
  @if (hasFilterInput()) {
    <div class="table-header">
      <mat-form-field floatPlaceholder="never">
        <input
          matInput
          #filter
          [placeholder]="'igo.common.table.filter' | translate"
        />
      </mat-form-field>
    </div>
  }

  <div class="table-container">
    <table mat-table #table [dataSource]="dataSource" matSort>
      <!-- Checkbox Column -->
      <ng-container matColumnDef="selectionCheckbox">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
          />
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"
          />
        </td>
      </ng-container>

      @for (column of model().columns; track column) {
        <ng-container [matColumnDef]="column.name">
          @if (column.sortable) {
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ column.title }}
            </th>
          }
          @if (!column.sortable) {
            <th mat-header-cell *matHeaderCellDef>{{ column.title }}</th>
          }
          @if (!column.html) {
            <td
              mat-cell
              *matCellDef="let row"
              class="mat-cell-text"
              [ngClass]="
                model().cellClassFunc ? model().cellClassFunc(row, column) : {}
              "
            >
              {{ getValue(row, column.name) }}
            </td>
          } @else {
            <td
              mat-cell
              *matCellDef="let row"
              class="mat-cell-text"
              [ngClass]="
                model().cellClassFunc ? model().cellClassFunc(row, column) : {}
              "
              [innerHTML]="getValue(row, column.name)"
            ></td>
          }
        </ng-container>
      }

      <!-- Action Column -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          @for (action of model().actions; track action) {
            <button
              mat-mini-fab
              [color]="getActionColor(action.color)"
              (click)="handleClickAction($event, action, row)"
            >
              <mat-icon>{{ action.icon }}</mat-icon>
            </button>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [ngClass]="model().rowClassFunc ? model().rowClassFunc(row) : {}"
        (click)="selection.toggle(row)"
      ></tr>
    </table>
  </div>
</div>
